import { render, staticRenderFns } from "./user-prize.vue?vue&type=template&id=1093c656&"
import script from "./user-prize.vue?vue&type=script&lang=js&"
export * from "./user-prize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports